import React from 'react';
import Svg from '../Svg';

const IconEqualNot = ({ ...props }) => (
  <Svg {...props} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
    <path
      opacity="0.9"
      fillRule="evenodd"
      clipRule="evenodd"
      d="M19.7071 4.29289C20.0976 4.68342 20.0976 5.31658 19.7071 5.70711L17.4142 8H19C19.5523 8 20 8.44772 20 9C20 9.55228 19.5523 10 19 10H15.4142L11.4142 14H19C19.5523 14 20 14.4477 20 15C20 15.5523 19.5523 16 19 16H9.41421L5.70711 19.7071C5.31658 20.0976 4.68342 20.0976 4.29289 19.7071C3.90237 19.3166 3.90237 18.6834 4.29289 18.2929L6.58579 16H5C4.44772 16 4 15.5523 4 15C4 14.4477 4.44772 14 5 14H8.58579L12.5858 10H5C4.44772 10 4 9.55228 4 9C4 8.44772 4.44772 8 5 8H14.5858L18.2929 4.29289C18.6834 3.90237 19.3166 3.90237 19.7071 4.29289Z"
    />
  </Svg>
);

export default IconEqualNot;
